import { FALLBACK_THEME } from '@/constants/themeConstants';
import http from '@/services/api';
const RESOURCE_NAME = 'api/themes';
let fetchedThemes = [];

export default {
  getAll() {
    return fetchedThemes.length
      ? Promise.resolve(fetchedThemes)
      : http
          .get(`${RESOURCE_NAME}/all`)
          .then(response => {
            fetchedThemes = response.data || [];
            return fetchedThemes;
          })
          .catch(() => [FALLBACK_THEME]);
  },

  getDefault() {
    return FALLBACK_THEME;
  },

  get(id) {
    return http.get(`${RESOURCE_NAME}/${id}`);
  },

  create(data = {}) {
    return http.post(RESOURCE_NAME, data);
  },

  update(id, data = {}) {
    return http.put(`${RESOURCE_NAME}/${id}`, data);
  },

  delete(id) {
    return http.delete(`${RESOURCE_NAME}/${id}`);
  }
};
